import { takeLatest } from 'redux-saga/effects';
import { CLIENT_MODULE, PARKING_METER_MODULE } from '../../../configs/moduleNames';
import {
  HOST_COMMAND_CANCEL,
  HOST_COMMAND_DISPATCH,
  LOAD_HISTORY_LIST,
  LOAD_HOST_COMPONENTS,
  LOAD_HOST_LIST,
  LOAD_HOST_STATUSES_LIST,
  LOAD_HOST_DETAIL,
  HISTORY_EXPORT_WORD,
  LOAD_HOST_STATUSES_HISTORY,
  LOAD_ZONES,
  HOST_PROBLEMS_DETAIL,
  LOAD_HOST_PROBLEMS,
} from '../actions';

import loadHostList from './loadHostList';
import loadHostComponents from './loadHostComponents';
import loadHistoryList from './loadHistoryList';
import hostCommandDispatch from './hostCommandDispatch';
import hostCommandCancel from './hostCommandCancel';
import loadHostStatusesList from './loadHostStatusesList';
import loadHostDetail from './loadHostDetail';
import hostHistoryExportWord from './hostHistoryExportWord';
import loadHostStatusesHistory from './loadHostStatusesHistory';
import loadZones from './loadZones';
import initParkingMeter from './initParkingMeter';
import hostProblemsDetail from './hostProblemsDetail';
import loadHostProblems from './loadHostProblems';
import { SUCCESSFUL } from '../../../configs/actionNames';
import { CLIENT_CHECK } from '../../Client/actions';

export default function* watchSystem() {
  yield takeLatest(CLIENT_MODULE + CLIENT_CHECK + SUCCESSFUL, initParkingMeter);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_LIST, loadHostList);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_COMPONENTS, loadHostComponents);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HISTORY_LIST, loadHistoryList);
  yield takeLatest(PARKING_METER_MODULE + HOST_COMMAND_DISPATCH, hostCommandDispatch);
  yield takeLatest(PARKING_METER_MODULE + HOST_COMMAND_CANCEL, hostCommandCancel);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST, loadHostStatusesList);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_DETAIL, loadHostDetail);
  yield takeLatest(PARKING_METER_MODULE + HISTORY_EXPORT_WORD, hostHistoryExportWord);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY, loadHostStatusesHistory);
  yield takeLatest(PARKING_METER_MODULE + LOAD_ZONES, loadZones);
  yield takeLatest(PARKING_METER_MODULE + HOST_PROBLEMS_DETAIL, hostProblemsDetail);
  yield takeLatest(PARKING_METER_MODULE + LOAD_HOST_PROBLEMS, loadHostProblems);
}
